<template>
	<div>
		<div v-if="showSettings" class="settings-popup">
			<!-- Close button for the popup -->
			<div class="close" @click="showSettings = false">
				<svg width="15" height="15" xmlns="http://www.w3.org/2000/svg" fill-rule="evenodd" clip-rule="evenodd">
					<path
						d="M15 13.459l-5.01-4.926 4.92-4.969-2.218-2.218-4.935 4.998-4.986-4.921L0 3.564l4.988 4.937-4.921 4.986L2.218 15l4.956-4.986 4.969 4.92z" />
				</svg>
			</div>
			<h2>Settings</h2>
			<div class="section">
				<h3>General</h3>
				<label>
					<input type="checkbox" v-model="considerYAsVowel"> Consider "Y" as a vowel
				</label>
			</div>
			<div class="section">
				<h3>Categories to include</h3>
				<div v-for="category in Object.keys(categories)" :key="category">
					<label>
						<input type="checkbox" v-model="selectedCategories" :value="category">
						{{ category }}
					</label>
				</div>
			</div>
		</div>
		<div class="hand-container">
			<div class="bg-gradient"></div>

			<img src="../assets/hands.png" alt="Hands Image" />

			<div v-for="position in 10" :key="position"
				:style="{ top: lightPositions[position - 1].y, left: lightPositions[position - 1].x }"
				class="light-effect" :class="{ 'active-light': activeLight === position }">
			</div>

			<div v-if="reveal" class="reveal">
				I was thinking of... {{ selectedWord }}!
			</div>

			<div v-if="!reveal && gameStarted" class="reveal">
				What word am I thinking of?
			</div>
			<div class="login-form" v-if="!loggedIn">
				<form @submit.prevent="checkPassword">
					<label>Password:
						<input v-model="password" type="password">
					</label>
					<button>Login</button>
					<p v-if="loginFailed" style="color: red;text-align: center;margin-top: 10px;">Password incorrect!
					</p>
				</form>
			</div>
		</div>
		<div class="controls">

			<button class="primary btn" v-if="!gameStarted && loggedIn" @click="startGame">Start</button>
			<button class="secondary btn light" v-if="!gameStarted && loggedIn"
				@click="showSettings = true">Settings</button>

			<div class="message" v-if="revealedCategory">Category: {{ selectedCategory }}</div>
			<div class="message" v-if="revealedLetterShape">Shape of First Letter: {{ letterShape }}</div>
			<div class="message" v-if="generatedWordFromLetter">{{ generatedWordFromLetter }}</div>

			<div v-if="gameStarted" class="game-controls">
				<button class="primary" @click="revealCategory">What's the Category?</button>
				<div class="letters">
					<h2>Figure out the letters</h2>
					<button class="primary" @click="showWordLength">How many letters?</button>
					<button class="primary" @click="showFirstVowel">Where's the first vowel?</button>
					<button class="primary" @click="showSecondVowel">Where's the second vowel?</button>
					<button class="primary" @click="revealLetterShape">What's the shape of the first letter?</button>
				</div>
				<div class="lexicon">
					<h2>Name a word beginning with the</h2>
					<span v-for="(n, index) in selectedWord" :key="index">
						<button class="primary" @click="getWordFromLetterIndex(index + 1)">{{ getOrdinalNumber(index + 1) }} letter</button>
					</span>
				</div>
				<br><br>
				<button class="success" @click="revealWord">Tell me the word!</button>
				<button class="error" @click="resetWord">Reset</button>
			</div>
		</div>
	</div>
</template>

<script>
export default {
	data() {
		return {
			password: '',
			correctPassword: 'jvb4JTX6xwu@bjv7krk',
			loggedIn: false,
			loginFailed: false,
			categories: {
				ManmadeInHand: ["ABACUS", "ACTIONMAN", "ADAPTOR", "AERIAL", "AERO", "AFTERSHAVE", "AFTERSUN", "AIRBRUSH", "AIRCON", "AIRCONDITIONER", "AIRFRESHENER", "AIRFRESHNER", "AIRFRIER", "AIRFRYER", "AIRPLANE", "AIRPOD", "AIRPODS", "AIRTAG", "ALARM", "ALARMCLOCK", "ALEXA", "ALUMINUMFOIL", "AMERICAN", "AMP", "AMPLIFIER", "ANALBEAD", "ANALBEADS", "ANCHOR", "ANTENNA", "ANVIL", "APP", "APPLE", "APPLEPIE", "APRON", "AQUARIUM", "ARMBAND", "ARMCHAIR", "ARMOUR", "ARMREST", "ARROW", "ARROWHEAD", "ASHTRAY", "ATLAS", "AUTOMOBILE", "AXE", "BACKPACK", "BADGE", "BAG", "BAGPIPE", "BAGPIPES", "BALL", "BALLOON", "BALLPOINTPEN", "BANDAID", "BANJO", "BANKNOTE", "BANNER", "BARBECUE", "BARBIE", "BAROMETER", "BARREL", "BASEBALL", "BASIN", "BASKET", "BASKETBALL", "BASS", "BATHMAT", "BATTERY", "BEACHBALL", "BEAD", "BEADS", "BEAKER", "BEANBAG", "BEANIE", "BEER", "BELL", "BELT", "BENCH", "BERET", "BIBLE", "BICYCLE", "BIKE", "BILLET", "BIN", "BINOCULARS", "BISCUIT", "BISCUITS", "BLACKBOARD", "BLADE", "BLANKET", "BLEACH", "BLENDER", "BLIND", "BLINDS", "BLOUSE", "BLUEMOON", "BLUNT", "BLUSHER", "BOARD", "BOARDGAME", "BOAT", "BODYARMOUR", "BOILER", "BOLLARD", "BOLT", "BOMB", "BONG", "BONGO", "BOOK", "BOOKMARK", "BOOMERANG", "BOOST", "BOOT", "BOPIT", "BOTTLE", "BOTTLECAP", "BOTTLEOPENER", "BOUNTY", "BOUQUET", "BOW", "BOWL", "BOWTIE", "BOX", "BOXERS", "BRA", "BRACELET", "BRACES", "BRACKET", "BREAD", "BREATHALYSER", "BRICK", "BRIEFCASE", "BROACH", "BROOM", "BRUSH", "BUBBLEGUM", "BUCKET", "BUENO", "BUGGY", "BUISNESSCARD", "BULB", "BULLET", "BULLETPROOFVEST", "BUMBAG", "BUN", "BUNGEE", "BUNGEECORD", "BUNTING", "BURGER", "BUSINESSCARD", "BUTTER", "BUTTON", "BUTTPLUG", "CABINET", "CABLE", "CAGE", "CAKE", "CALCULATOR", "CALENDAR", "CALIPER", "CALLIPER", "CAMCORDER", "CAMERA", "CAN", "CANDELABRA", "CANDLE", "CANDLESTICK", "CANDY", "CANE", "CANOE", "CANOPENER", "CANVAS", "CAP", "CAPGUN", "CAPO", "CAPSULE", "CAPTAIN", "CARAFE", "CARAMEL", "CARD", "CARDBOARD", "CARDBOARDBOX", "CARDIGAN", "CARDS", "CARKEY", "CARKEYS", "CARLING", "CARLSBERG", "CARMEX", "CARPET", "CART", "CARTON", "CARTRIDGE", "CASE", "CASKET", "CASSETTE", "CASSETTETAPE", "CAST", "CATALOGUE", "CATFLAP", "CAULDRON", "CAULK", "CD", "CELLO", "CELLOTAPE", "CELLPHONE", "CELLULARPHONE", "CEREAL", "CERTIFICATE", "CHAIN", "CHAINS", "CHAINSAW", "CHAIR", "CHALK", "CHAMPAGNE", "CHANDELIER", "CHAPSTICK", "CHARGER", "CHARM", "CHECK", "CHEESE", "CHEESEBURGER", "CHEESECAKE", "CHEQUE", "CHEQUEBOOK", "CHESS", "CHESSBOARD", "CHESSSET", "CHEST", "CHEWINGGUM", "CHIP", "CHIPS", "CHISEL", "CHOCOLATE", "CHOPPINGBOARD", "CHOPSTICK", "CHOPSTICKS", "CIGAR", "CIGARETTE", "CLAMP", "CLARINET", "CLAYMORE", "CLEANSER", "CLEATS", "CLIP", "CLIPBOARD", "CLIPPERS", "CLOCK", "CLOTH", "CLUTCH", "COASTER", "COAT", "COATHANGER", "COCACOLA", "COCK", "COCKRING", "COCKTAIL", "COFFEE", "COFFEEPOT", "COFFIN", "COIN", "COKE", "COLA", "COLLAR", "COLOGNE", "COLOR", "COLORINGBOOK", "COLORS", "COLOURINGBOOK", "COLOURS", "COMB", "COMFORTER", "COMIC", "COMICBOOK", "COMPASS", "COMPENDIUM", "COMPUTER", "CONCEALER", "CONCRETE", "CONDITIONER", "CONDOM", "CONDOMS", "CONE", "CONSOLE", "CONTACTLENS", "CONTACTLENSE", "CONTACTLENSES", "CONTAINER", "CONTROLLER", "CONVERTER", "COOKIE", "COOKIES", "COOLER", "COPIER", "CORD", "CORK", "CORKSCREW", "CORNICE", "COSTUME", "COT", "COTTONBUD", "COTTONWOOL", "COUPON", "CRACKER", "CRADLE", "CRATE", "CRAVAT", "CRAYON", "CREAM", "CREAMER", "CREDITCARD", "CRICKETBALL", "CRICKETBAT", "CRISP", "CRISPS", "CROISSANT", "CROSS", "CROSSBOW", "CROSSWORD", "CROWBAR", "CRUCIFIX", "CRUTCH", "CRYSTAL", "CUBE", "CUE", "CUFFLINK", "CUFFLINKS", "CUM", "CUP", "CUPBOARD", "CURLERS", "CURLINGIRON", "CURTAIN", "CURTAINS", "CUSHION", "CYCLE", "DAGGER", "DART", "DARTBOARD", "DEBITCARD", "DECANTER", "DECK", "DECKCHAIR", "DENTALFLOSS", "DENTURE", "DEODORANT", "DESK", "DESSERT", "DIABOLO", "DIAMOND", "DIAPER", "DIAPERS", "DIARY", "DICE", "DICK", "DICTIONARY", "DIDGERIDOO", "DIFFUSER", "DILDO", "DISC", "DISH", "DISINFECTANT", "DOLL", "DOLLARBILL", "DOMINO", "DOODLE", "DOOR", "DOORKNOB", "DOORMAT", "DOUGHNUT", "DRAIN", "DRAPES", "DRAWING", "DRAWINGPIN", "DREAMCATCHER", "DRESS", "DRILL", "DRONE", "DRPEPPER", "DRUM", "DUCKTAPE", "DUMBBELL", "DUMMY", "DUREX", "DUSTER", "DUSTPAN", "DUVET", "DVD", "DYNAMITE", "DYSON", "EARMUFF", "EARMUFFS", "EARPLUG", "EARPLUGS", "EARRING", "EARRINGS", "EASEL", "EASTEREGG", "EGGTIMER", "ELASTIC", "ELEPHANT", "ENCYCLOPAEDIA", "ENVELOPE", "ERASER", "EXACTOBLADE", "EXACTOKNIFE", "EXTINGUISHER", "EYELASHES", "EYEPATCH", "FACEBOOK", "FACECREAM", "FACEMASK", "FAG", "FAN", "FANNYPACK", "FAXMACHINE", "FEATHER", "FENCE", "FIGURINE", "FILOFAX", "FILTER", "FIREEXTINGUISHER", "FIREHYDRANT", "FIREWORK", "FISH", "FISHBOWL", "FISHINGNET", "FISHINGPOLE", "FISHINGROD", "FITBIT", "FLAG", "FLANNEL", "FLASHLIGHT", "FLASK", "FLATCAP", "FLIPCHART", "FLIPFLOP", "FLIPFLOPS", "FLIPPER", "FLIPPERS", "FLOAT", "FLOPPYDISC", "FLOSS", "FLOWER", "FLUTE", "FLYER", "FOIL", "FOOTBALL", "FOOTSTALL", "FORCEPS", "FORK", "FOUNDATION", "FRAME", "FRIES", "FRISBEE", "FRUITCAKE", "FRYER", "FRYINGPAN", "FUNNEL", "GALAXY", "GAMEBOY", "GATE", "GAVEL", "GEAR", "GEARSTICK", "GEL", "GENERATOR", "GHOST", "GIFTBAG", "GLASS", "GLASSES", "GLOBE", "GLOVE", "GLOVES", "GLOWSTICK", "GLUE", "GNOME", "GOGGLES", "GOLD", "GOLFCLUB", "GOOGLE", "GOWN", "GRAMOPHONE", "GRATER", "GRENADE", "GRIDDLE", "GRILL", "GRINDER", "GUITAR", "GUM", "GUN", "GYROSCOPE", "HAIRBAND", "HAIRBRUSH", "HAIRCLAY", "HAIRCLIP", "HAIRDRYER", "HAIRGEL", "HAIRSPRAY", "HAIRTIE", "HAIRWAX", "HAMBURGER", "HAMMER", "HAMMOCK", "HANDBAG", "HANDBREAK", "HANDCREAM", "HANDCUFF", "HANDCUFFS", "HANDGUN", "HANDKERCHIEF", "HANDLE", "HANDWARMER", "HANGER", "HARDDRIVE", "HARMONICA", "HARNESS", "HAT", "HATCHET", "HEADPHONES", "HEADSET", "HEATER", "HEIRLOOM", "HELICOPTER", "HELMET", "HIGHHEEL", "HIGHHEELS", "HINGE", "HOE", "HOLEPUNCH", "HOODIE", "HOOK", "HOOVER", "HORSESHOE", "HOSE", "HUBCAP", "HULAHOOP", "HYDRANT", "ICEBOX", "ICECHEST", "ICECREAM", "ICECUBE", "ICEPACK", "ICETRAY", "INCENSE", "INDICATOR", "INEARS", "INHALER", "INKCARTRIDGE", "INSTAGRAM", "INUKSHUK", "IPAD", "IPHONE", "IPOD", "IRNBRU", "IRON", "IRONINGBOARD", "JACKDANIELS", "JACKET", "JAR", "JAVELIN", "JEANS", "JELLY", "JENGA", "JERSEY", "JEWELRY", "JOURNAL", "JOYSTICK", "JUG", "JUICE", "JUICER", "JUMPER", "JUMPINGJACK", "JUUL", "KAYAK", "KEBAB", "KEG", "KETTLE", "KETTLEBELL", "KEY", "KEYBOARD", "KEYCHAIN", "KEYPAD", "KEYRING", "KEYS", "KINDLE", "KITCHENROLL", "KITKAT", "KLEENEX", "KNICKERS", "KNIFE", "KNOB", "KNUCKLEDUSTER", "KOMBUCHA", "LABEL", "LACE", "LADDER", "LADLE", "LAGER", "LAMP", "LAMPPOST", "LAMPSHADE", "LANTERN", "LANYARD", "LAPTOP", "LASAGNE", "LAWNMOWER", "LEAD", "LEAFBLOWER", "LEAFLET", "LEMONADE", "LENS", "LETTER", "LETTERBOX", "LICENSEPLATE", "LIGHT", "LIGHTBULB", "LIGHTER", "LILO", "LION", "LIPGLOSS", "LIPSALVE", "LIPSTICK", "LOAF", "LOAFERS", "LOCK", "LOCKER", "LOCKET", "LOLLIPOP", "LOLLY", "LOOFAH", "LOTION", "LUBE", "LUGGAGE", "LUNCH", "LUNCHBOX", "LUNCHSACK", "MACHETE", "MACRAME", "MAGAZINE", "MAGICMARKER", "MAGICWAND", "MAGNET", "MAGNIFYING", "MAGNIFYINGGLASS", "MAIL", "MANDOLIN", "MANUAL", "MAP", "MARACAS", "MARBLE", "MARKER", "MARKERPEN", "MARRACAS", "MARS", "MARSBAR", "MASCARA", "MASHER", "MASK", "MASTERCARD", "MAT", "MATCH", "MATCHBOX", "MATCHES", "MATTRESS", "MAYONNAISE", "MEDAL", "MEDALLION", "MEDICATION", "MEDICINE", "MEGAPHONE", "MEMORYBANK", "MEMORYCARD", "MEMORYSTICK", "MENORAH", "MENU", "METAL", "MICROCHIP", "MICROPHONE", "MICROWAVE", "MILK", "MILKSHAKE", "MILKYBAR", "MILKYWAY", "MILLIVOLTMETER", "MINIDISC", "MINT", "MIRROR", "MIXER", "MOBILE", "MOCCASIN", "MODELAIRPLANE", "MODELCAR", "MODEM", "MOISTURISER", "MONEY", "MONEYCLIP", "MONITOR", "MONOCLE", "MONOPOLY", "MOP", "MORTAR", "MOUSE", "MOUSEMAT", "MOUSEPAD", "MOUSETRAP", "MOUSSE", "MOUTHWASH", "MUG", "NAIL", "NAILFILE", "NAILPOLISH", "NAILWRITER", "NAPKIN", "NAPPY", "NECKLACE", "NECKTIE", "NEEDLE", "NEWLIST", "NEWSPAPER", "NIGHTY", "NINTENDO", "NOODLE", "NOODLES", "NOSERING", "NOTE", "NOTEBOOK", "NOTEPAD", "NUT", "OCULUS", "OINTMENT", "OPENER", "ORANGINA", "ORGAN", "ORNAMENT", "OVENGLOVE", "OVENGLOVES", "PACIFIER", "PACKAGE", "PACKET", "PAD", "PADDLE", "PADLOCK", "PAGE", "PAGER", "PAIL", "PAINT", "PAINTBRUSH", "PANEL", "PANTIES", "PANTS", "PAPER", "PAPERBAG", "PAPERCLIP", "PAPERSACK", "PAPERWEIGHT", "PARACHUTE", "PARCHMENT", "PASTA", "PAVLOVA", "PEARL", "PECANPIE", "PEELER", "PEG", "PEN", "PENCIL", "PENCILCASE", "PENCILSHARPENER", "PENDANT", "PENKNIFE", "PEPSI", "PERCOLATOR", "PERFUME", "PERONI", "PESTLE", "PETROLEUM", "PHONE", "PHONEBOOK", "PHONECASE", "PHOTO", "PHOTOFRAME", "PHOTOGRAPH", "PIANO", "PICTIONARY", "PICTURE", "PIE", "PIGGYBANK", "PIJAMAS", "PILL", "PILLBOX", "PILLOW", "PILLOWCASE", "PILLS", "PIN", "PINATA", "PINCUSHION", "PINGPONGBALL", "PINT", "PINTGLASS", "PIPE", "PIPETTE", "PISTOL", "PIZZA", "PIÑATA", "PLANTPOT", "PLASTER", "PLASTIC", "PLASTICBAG", "PLATE", "PLAYSTATION", "PLECTRUM", "PLIERS", "PLUG", "PLUNGER", "POCKETKNIFE", "POGO", "POGOSTICK", "POISON", "POKERCHIP", "POLE", "POLISH", "POOLBALL", "POOLCUE", "POPCORN", "POPPER", "POPSICLE", "PORCELAIN", "PORTFOLIO", "POSTCARD", "POSTER", "POSTIT", "POSTITNOTES", "POT", "POTATOPEELER", "POUCH", "POUND", "POWERBANK", "POWERPACK", "PRAM", "PRINTER", "PROJECTOR", "PROSECCO", "PROTRACTOR", "PUMP", "PUMPKIN", "PUPPET", "PURIFIER", "PURSE", "PUZZLEPIECE", "PYJAMAS", "QTIP", "QUILL", "QURAN", "RACK", "RACKET", "RADIATOR", "RADIO", "RAG", "RAILING", "RAKE", "RAZOR", "RAZORBLADE", "RECEIPT", "RECORD", "RECORDER", "REMOTE", "RESERVED", "RETAINER", "RIBBON", "RIFLE", "RIM", "RING", "RIZLA", "ROD", "ROLEX", "ROLLER", "ROLLERBLADE", "ROLLINGPIN", "ROOMFRESHNER", "ROPE", "ROUTER", "ROVER", "RUBBER", "RUBBERBAND", "RUBIKSCUBE", "RUG", "RULER", "SACK", "SADDLE", "SAFETYBELT", "SAFETYPIN", "SALTSHAKER", "SAND", "SANDALS", "SANDER", "SANDPAPER", "SANDWICH", "SANITISER", "SATELLITE", "SAUCEPAN", "SAUCER", "SAUSAGE", "SAUSAGEROLL", "SAXOPHONE", "SCALE", "SCALES", "SCANNER", "SCARF", "SCEPTRE", "SCISSORS", "SCONCE", "SCOOTER", "SCRABBLE", "SCRATCHCARD", "SCREEN", "SCREW", "SCREWDRIVER", "SCRIPT", "SCRUNCHIE", "SCRUNCHIES", "SCRUNCHY", "SCULPTURE", "SEAT", "SEATBELT", "SEGWAY", "SELLOTAPE", "SERVIETTE", "SEXDOLL", "SHAKER", "SHAMPOO", "SHARPENER", "SHARPIE", "SHAVER", "SHEET", "SHEETS", "SHELVES", "SHIRT", "SHIV", "SHOE", "SHOEBOX", "SHOELACE", "SHOES", "SHOPPINGCART", "SHORTBREAD", "SHORTS", "SHOTGUN", "SHOVEL", "SHOWERCAP", "SHOWERCURTAIN", "SHOWERGEL", "SHOWERHEAD", "SHUTTERS", "SHUTTLECOCK", "SIEVE", "SIGN", "SILK", "SILVERWARE", "SINK", "SKATEBOARD", "SKETCHBOOK", "SKEWER", "SKIPPINGROPE", "SKIRT", "SKIS", "SKITTLE", "SLAB", "SLEDGE", "SLEDGEHAMMER", "SLING", "SLINGSHOT", "SLINKY", "SLIPPER", "SLIPPERS", "SMARTPHONE", "SNARE", "SNEAKER", "SNEAKERS", "SNICKERS", "SNOOKERBALL", "SNORKEL", "SNOWBALL", "SNOWBOARD", "SNOWGLOBE", "SOAP", "SOCCERBALL", "SOCK", "SOFA", "SORBET", "SOUP", "SPACER", "SPAGHETTI", "SPANNER", "SPARKLERSPATULA", "SPATULAR", "SPEAKER", "SPEAR", "SPECTACLES", "SPINNINGTOP", "SPLIFF", "SPOKE", "SPONGE", "SPOON", "SPRAY", "SPRAYCAN", "SPRAYPAINT", "SPRING", "SPRINKLER", "SPRITE", "SPRITZER", "SPYGLASS", "STAMP", "STAND", "STAPLE", "STAPLER", "STATUE", "STETHOSCOPE", "STICKER", "STICKERS", "STILETTO", "STIRRER", "STOOL", "STRAINER", "STRAW", "STREAMER", "STRIMMER", "STRING", "STROLLER", "STYROFOAM", "SUB", "SUGAR", "SUITCASE", "SUNCREAM", "SUNGLASSES", "SUPERGLUE", "SURFBOARD", "SUSHI", "SUSHIROLL", "SUSPENDER", "SUSPENDERS", "SWEATBAND", "SWEATER", "SWIMMERS", "SWITCH", "SWORD", "SYRINGE", "TABLE", "TABLESPOON", "TABLET", "TACO", "TAG", "TAKEOUT", "TAMAGOTCHI", "TAMPAX", "TAMPON", "TANKARD", "TAP", "TAPE", "TAPEMEASURE", "TAPERECORDER", "TATTOO", "TAXIDERMY", "TEABAG", "TEALIGHT", "TEAPOT", "TEASPOON", "TEATOWEL", "TEDDY", "TEDDYBEAR", "TELEPHONE", "TELESCOPE", "TELEVISION", "TENNIS BALL", "TENNISBALL", "TENT", "TEQUILA", "TESTTUBE", "THERMOMETER", "THERMOSTAT", "THESAURUS", "THIMBLE", "THONG", "THREAD", "THUMBTACK", "TICKET", "TIE", "TILE", "TIMER", "TINOPENER", "TIRE", "TISSUE", "TOASTER", "TOBACCO", "TOBOGGAN", "TOILET", "TOILETPAPER", "TOKEN", "TONGS", "TOOTH", "TOOTHBRUSH", "TOOTHPASTE", "TOOTHPICK", "TOP", "TOPHAT", "TORCH", "TORTILLA", "TOWEL", "TOYAIRPLANE", "TOYCAR", "TOYMOUSE", "ΤΟΥΡΟΤ", "TOYRAT", "TOYSOLDIER", "TOYTRUCK", "TRAINER", "TRAINERS", "TRAMPOLINE", "TRANSFORMER", "TRANSISTOR", "TRAP", "TRAPDOOR", "TRASHBIN", "TRASHCAN", "TRAY", "TREADMILL", "TREASURE", "TRENCHCOAT", "TRIANGLE", "TRICYCLE", "TRIMMER", "TRIMMERS", "TROMBONE", "TROPHY", "TROUSERS", "TROWEL", "TRUMPET", "TRUNK", "TRUNKS", "TSHIRT", "TUBA", "TUBE", "TUMBLER", "TUPPERWARE", "TURPENTINE", "TURTLENECK", "TWEEZER", "TWEEZERS", "TWIX", "TYPEWRITER", "TYRE", "UMBRELLA", "UNDERWEAR", "UNICYCLE", "UNIFORM", "URN", "USB", "USBSTICK", "VACUUM", "VAPE", "VARNISH", "VASE", "VASELINE", "VEIL", "VENT", "VENTILATOR", "VEST", "VIAL", "VIBRATOR", "VICE", "VIDEO", "VIDEOGAME", "VIDEOTAPE", "VIMTO", "VINYL", "VIOLIN", "VISACARD", "VITAMIN", "VITAMINS", "VODKA", "WAISTCOAT", "WALKIETALKIE", "WALLET", "WAND", "WASHER", "WATCH", "WATERCAN", "WATERINGCAN", "WATERPISTOL", "WAX", "WHEEL", "WHEELBARROW", "WHIP", "WHISK", "WHISKY", "WHISTLE", "WHITEBOARD", "WIG", "WINDOW", "WINDOWFRAME", "WINE", "WINEGLASS", "WIPE", "WIRE", "WOK", "WRAP", "WRENCH", "XBOX", "XYLOPHONE", "YO YO", "YOGAMAT", "YOYO", "ZIP", "ZIPPER", "ZIPPO"],
				ManmadeBig: ["AIRCRAFT", "AIRPLANE", "ALLEY", "ALTAR", "AMBULANCE", "AMPLIFIER", "ANCHOR", "APARTMENT", "AQUARIUM", "ARCHWAY", "ARMCHAIR", "ATM", "AUDI", "AUTO", "AUTOMOBILE", "AWNING", "BALCONY", "BANISTER", "BANNER", "BAR", "BARBECUE", "BARBERS", "BARGE", "BARGEPOLE", "BARREL", "BARRIER", "BASEMENT", "BASIN", "BATH", "BATHROOM", "BATHTUB", "BATTLESHIP", "BED", "BEDROOM", "BELL", "BENCH", "BICYCLE", "BIKE", "BILLBOARD", "BLACKBOARD", "BLIND", "BLINDS", "BUS", "CABIN", "CABINET", "CAFE", "CAGE", "CANOE", "CAR", "CARAVAN", "CARPARK", "CARPET", "CARRIAGE", "CASHMACHINE", "CASTLE", "CATHEDRAL", "CAULDRON", "CAVE", "CEILING", "CELLO", "CEMETERY", "CHAIR", "CHANDELIER", "CHECKOUT", "CHEST", "CHIMNEY", "CHURCH", "COACH", "COFFIN", "COLISEUM", "COLOSSEUM", "COLUMN", "COMPOST", "CONCORD", "CONCRETE", "CONDO", "CONE", "CONSERVATORY", "CONVERTIBLE", "COOKER", "CORRIDOR", "COSTUME", "COUCH", "COUNTER", "COURTHOUSE", "CRADLE", "CRANE", "CRASHDUMMY", "CREMATORIUM", "CREMATORY", "CROSSING", "CRUISE", "CUBICLE", "CUPBOARD", "CURTAIN", "CURTAINS", "CYCLE", "DECKCHAIR", "DECKING", "DEN", "DESK", "DIGGER", "DISH", "DISHWASHER", "DOOR", "DRAINPIPE", "DRESSER", "DRIVEWAY", "EARTHQUAKE", "ELEVATOR", "ENGINE", "ESCALATOR", "FAN", "FEATURE", "FERRARI", "FIRE", "FIREENGINE", "FIREPLACE", "FIRETRUCK", "FLAT", "FLIPCHART", "FLOOR", "FLOORBOARD", "FOOTBRIDGE", "FOOTPATH", "FORKLIFT", "FORT", "FOUNTAIN", "FRAME", "FREEWAY", "FREEZER", "FRIDGE", "FRIDGEFREEZER", "FURNACE", "GAMESHOW", "GARAGE", "GARDEN", "GASSTOVE", "GLASS", "GONG", "GRAMOPHONE", "GRATE", "GRAVEYARD", "GUN", "GYM", "GYMNASIUM", "HAIRDRESSER", "HALLWAY", "HAMMOCK", "HARP", "HEATER", "HEIRLOOM", "HELICOPTER", "HELIPAD", "HIGHCHAIR", "HIGHSTREET", "HIGHWAY", "HOOVER", "HOSPITAL", "HOSTEL", "HOTEL", "HOTTUB", "HOUSE", "HYDROFOIL", "HYDROPLANE", "IGLOO", "INCUBATOR", "INFIRMARY", "INUKSHUK", "IRONINGBOARD", "JACUZZI", "JAGUAR", "JET", "JETSKI", "JUMBOJET", "KAYAK", "KEYBOARD", "KITCHEN", "LAB", "LABORATORY", "LADDER", "LAMP", "LAMPPOST", "LAVATORY", "LAWNMOWER", "LETTERBOX", "LIDO", "LIFT", "LIMO", "LIMOUSINE", "LIVINGROOM", "LOCKER", "LOGCABIN", "LORRY", "LUGGAGE", "MAISONETTE", "MALL", "MANNEQUIN", "MARKET", "MARQUEE", "MARQUIS", "MASSAGECHAIR", "MATTRESS", "MERCEDES", "MIRROR", "MISSILE", "MOTORBIKE", "MOTORWAY", "MOUNTAIN", "MOWER", "NEWSAGENT", "NIGHTCLUB", "ORCHESTRA", "ORGAN", "OVEN", "OVERPASS", "PACKAGE", "PAINT", "PAINTING", "PANEL", "PANTRY", "PARACHUTE", "PARK", "PATH", "PAVEMENT", "PEUGEOT", "PEW", "PHOTOCOPIER", "PIANO", "PILLAR", "PLANE", "PLASTIC", "PLATFORM", "PLAYGROUND", "POLE", "POND", "POOL", "POSTBOX", "POSTER", "PRAM", "PRISON", "PUB", "PUMP", "PYLON", "PYRAMID", "PYRAMIDS", "RADIATOR", "RAIL", "RAILINGS", "RAILWAY", "RECLINER", "REFRIGERATOR", "RESTAURANT", "RESTROOM", "ROAD", "ROCKET", "ROCKINGCHAIR", "ROLLERCOASTER", "ROOF", "ROOFRACK", "ROUNDABOUT", "SAFE", "SAILBOAT", "SAILINGBOAT", "SATELLITE", "SAUNA", "SCAFFOLDING", "SCALE", "SCALES", "SCARECROW", "SCULPTURE", "SEESAW", "SEGWAY", "SEWERS", "SHED", "SHELTER", "SHIP", "SHOP", "SHOPPINGMALL", "SHOWER", "SHUTTLE", "SIDEWALK", "SIGNPOST", "SINK", "SKYLIGHT", "SKYSCRAPER", "SLIDE", "SLIDINGDOOR", "SOFA", "SOFABED", "SPA", "SPACESHIP", "SPACESHUTTLE", "SPACESTATION", "SPEAKER", "SPEAKERS", "SPEAR", "SPEEDBOAT", "STADIUM", "STAGE", "STAIRCASE", "STAIRS", "STATION", "STATUE", "STEEPLE", "STEPLADDER", "STEPS", "STOREROOM", "STOVE", "STREET", "STREETLAMP", "STREETLIGHT", "STYROFOAM", "SUBMARINE", "SUITCASE", "SUNBED", "SUPERMARKET", "SWIMMINGPOOL", "SWING", "TABLE", "TANK", "TANKER", "TAXI", "TAXIDERMY", "TELESCOPE", "TELEVISION", "TENT", "TERRACE", "TESLA", "THEATRE", "THEMEPARK", "TILE", "TILL", "TOILET", "TORPEDO", "TOWER", "TRACTOR", "TRAFFICLIGHT", "TRAILER", "TRAIN", "TRAINTRACK", "TRAINTRACKS", "TRANSFORMER", "TRAPDOOR", "TREADMILL", "TREE", "TREEHOUSE", "TRICYCLE", "TROLLEY", "TRUCK", "TRUNK", "TUB", "TUBE", "TUMBLEDRYER", "TUNNEL", "TURBINE", "TV", "TYPEWRITER", "UFO", "UNDERGROUND", "UNDERPASS", "UNICYCLE", "VENT", "VENTILATOR", "VILLAGE", "VINEYARD", "WAGON", "WALL", "WALLPAPER", "WAREHOUSE", "WASHINGMACHINE", "WASHROOM", "WATCHTOWER", "WATERJUG", "WELL", "WESTFIELD", "WESTFIELDS", "WHEELBARROW", "WHEELCHAIR", "WHITEBOARD", "WINDMILL", "WINDOW", "WINDOWFRAME", "WINDTURBINE", "WIRE", "WORKSURFACE", "YACHT", "ZEPPELIN", "ZOO", "ZORB"],
				NaturalInHand: ["ACORN", "AIR", "ALMOND", "ALMONDS", "AMBER", "ANIMAL", "APPLE", "APRICOT", "ATOM", "AUBERGINE", "BANANA", "BARK", "BEAN", "BEETLE", "BEETROOT", "BLACKBERRY", "BLUEBERRY", "BONE", "BRANCH", "BRAZILNUT", "BROCCOLI", "BUG", "CABBAGE", "CACTUS", "CARBON", "CARDAMOM", "CARROT", "CASHMERE", "CELL", "CHARM", "CHILLI", "CLAM", "CLEMENTINE", "CLOUD", "CLOVE", "COAL", "COCK", "COCKLE", "COCOON", "COFFEE", "COFFEEBEAN", "CONCRETE", "CONCRETE", "COPPER", "COTTON", "COURGETTE", "CRANBERRY", "CRYSTAL", "CUCUMBER", "DAFFODIL", "DIAMOND", "DICK", "DIRT", "DUST", "EGGSHELL", "ELECTRIC", "ELECTRICITY", "EMERALD", "ENERGY", "FEATHER", "FIRE", "FISH", "FLOUR", "FLOWER", "FRUIT", "GEM", "GEMSTONE", "GHOST", "GIFT", "GLASS", "GOLD", "GOOSEBERRY", "GRAPE", "GRASS", "GRIT", "HAIR", "HAZELNUT", "HEART", "HEATHER", "HEIRLOOM", "HERB", "ICE", "ICECUBE", "INK", "IRON", "JADE", "JUICE", "KUMQUAT", "LADYBUG", "LEAF", "LEMON", "LENTIL", "LIGHT", "LILLY", "LIME", "LIVER", "MAGNET", "MARBLE", "MELON", "METAL", "MONSTERA", "MOSS", "MUD", "MUSSEL", "NEST", "NUT", "OIL", "OLIVE", "ONION", "ORANGE", "OYSTER", "PAINT", "PANSY", "PAPER", "PARSNIP", "PEA", "PEACH", "PEANUT", "PEAR", "PEARL", "PEBBLE", "PENIS", "PEPPER", "PINEAPPLE", "PINECONE", "PLANT", "PLUM", "POD", "POO", "POOP", "POTATO", "PRUNE", "PULSE", "PUMPKIN", "QUARTZ", "QUILL", "RAINBOW", "RAISIN", "RHUBARB", "RICE", "ROCK", "ROPE", "ROSE", "ROSEBUD", "RUBY", "RUNNERBEAN", "SALT", "SAND", "SAPPHIRE", "SEASHELL", "SEAWEED", "SEED", "SHELL", "SHIT", "SILK", "SKIN", "SKULL", "SLAB", "SNOWBALL", "SNOWFLAKE", "SOIL", "SOUP", "SPACE", "SPICE", "SPICES", "SPINACH", "STARDUST", "STEAM", "STICK", "STONE", "STRAWBERRY", "STRING", "SUNFLOWER", "SUNSHINE", "SWEETCORN", "TATTOO", "THREE", "THYME", "TIME", "ΤΟΜΑΤΟ", "TOOL", "TULIP", "TURNIP", "TWIG", "TWO", "VEIN", "WALNUT", "WATER", "WATERMELON", "WEED", "WILDLIFE", "WIRE", "WOOL", "WORM"],
				NaturalBig: ["ATLAS", "BEACH", "BUSH", "CACTUS", "CANAL", "CAVE", "CLIFF", "CLOUD", "CLOUDS", "COUNTRY", "COUNTRYSIDE", "CREEK", "CREVASSE", "DESSERT", "ENERGY", "ESTUARY", "FARM", "FIELD", "FIRE", "GALAXY", "GHOST", "HAIL", "HEDGE", "JUNGLE", "LAKE", "LAND", "LAVA", "LIGHT", "LIGHTNING", "MEADOW", "MINERAL", "MONSTERA", "MOUNTAIN", "NEST", "OCEAN", "PATH", "PATHWAY", "PLANET", "POND", "RAIL", "RAIN", "RAINBOW", "RAINFOREST", "RAINFORREST", "RESERVOIR", "RIVER", "ROCK", "ROSEBUSH", "ROSEGARDEN", "SEA", "SEAWEED", "SLEET", "SNOW", "SPACE", "STAR", "STONE", "STORM", "STREAM", "SUN", "THUNDER", "TIME", "TREE", "VINEYARD", "VOLCANO", "WATERFALL", "WILDLIFE", "WORLD"],
				Animals: ["AARDVARK", "ADDER", "ALLIGATOR", "ANACONDA", "ANCHOVIE", "ANGELFISH", "ANTEATER", "ANTELOPE", "ARMADILLO", "BABOON", "BADGER", "BANDICOOT", "BASSS", "BEAGLE", "BEAR", "BEATLE", "BEAVER", "BEE", "BEETLE", "BISON", "BLACKBIRD", "BLUETIT", "BOA", "BOACONSTRICTOR", "BOBCAT", "BOXER", "BUG", "BULLDOG", "BULLFROG", "BULLMASTIFF", "BUMBLEBEE", "BUTTERFLY", "BUZZARD", "CALF", "CAMEL", "CANARY", "CAPYBARA", "CARP", "CAT", "CATERPILLAR", "CATFISH", "CATTLE", "CENTIPEDE", "CHAMELEON", "CHEETAH", "CHICKEN", "CHIHUAHUA", "CHIMPANZEE", "CICADA", "COBRA", "COCKATOO", "COCKROACH", "COD", "CORGI", "COUGAR", "COW", "CRAB", "CRANEFLY", "CRAYFISH", "CRICKET", "CROCODILE", "CROW", "CUTTLEFISH", "DACHSHUND", "DALMATIAN", "DEER", "DODO", "DOG", "DOLPHIN", "DONKEY", "DORMOUSE", "DRAGONFLY", "DUCK", "EAGLE", "EARTHWORM", "EEL", "ELEPHANT", "FALCON", "FERRET", "FINCH", "FIREFLY", "FISH", "FLAMINGO", "FLY", "FOX", "FOXHOUND", "FROG", "GAZELLE", "GECKO", "GELDING", "GERBIL", "GERMANSHEPHERD", "GIBBON", "GIRAFFE", "GLOWWORM", "GOAT", "GOLDCREST", "GOLDENEAGLE", "GOLDENRETRIEVER", "GOLDFISH", "GOOSE", "GOPHER", "GORILLA", "GOSHAWK", "GRASSHOPPER", "GRASSSNAKE", "GREATDANE", "GREENFLY", "GREENFROG", "GRIZZLYBEAR", "GUINEAPIG", "HADDOCK", "HALIBUT", "HAMSTER", "HARE", "HAWK", "HEFFER", "HERON", "HIPPO", "HIPPOPOTAMUS", "HORNET", "HORSE", "HORSEFLY", "HUMAN", "HUMMINGBIRD", "HUSKY", "HYENA", "IBEX", "IGUANA", "INSECT", "JACKAL", "JAGUAR", "JELLYFISH", "KANGAROO", "KINGFISHER", "KOALA", "LADYBIRD", "LADYBUG", "LAMA", "LAMB", "LEOPARD", "LIGER", "LION", "LIZARD", "LIZZARD", "LLAMA", "LOBSTER", "LOCUST", "LUMPFISH", "MACKEREL", "MAGGOT", "MAGPIE", "MALLARD", "MANDRILL", "MARLIN", "MASTIF", "MASTIFF", "MAYFLY", "MONGOOSE", "MONKEY", "MOOSE", "MOSQUITO", "MOTH", "MOUSE", "MULE", "NARWHAL", "NEWT", "NIGHTINGALEOCTOPUS", "ORANGUTAN", "OSTRICH", "OTTER", "OWL", "OYSTER", "PANDA", "PANTHER", "PARAKEET", "PARROT", "PARTRIDGE", "PEACOCK", "PELICAN", "PENGUIN", "PHEASANT", "PIG", "PIGEON", "PIPISTRELLE", "PIRANHA", "PITBULL", "PLATYPUS", "PONY", "POODLE", "PRAWN", "PUFFIN", "PUMA", "PYTHON", "QUAIL", "RABBIT", "RACCOON", "RAT", "RATTLESNAKE", "RAVEN", "REINDEER", "RETRIEVER", "RHINO", "RHINOCEROS", "ROADRUNNER", "ROBIN", "ROOSTER", "ROTTWEILER", "SALAMANDER", "SALMON", "SAUSAGE", "SCALLOP", "SCORPION", "SEABASS", "SEAGULL", "SEAHORSE", "SEAL", "SHARK", "SHEEP", "SHEEPDOG", "SHREW", "SHRIMP", "SIDEWINDER", "SILKWORM", "SILVERBACK", "SKUNK", "SLOTH", "SLUG", "SNAIL", "SNAKE", "SNAPPER", "SPANIEL", "SPARROW", "SPIDER", "SQUID", "SQUIRREL", "STALK", "STARFISH", "STARLING", "STURGEON", "SWALLOW", "SWALLOWTAIL", "SWAN", "SWORDFISH", "TADPOLE", "TARANTULA", "TERMITE", "TERRIER", "THRUSH", "TICK", "TIGER", "TOAD", "TORTOISE", "TOUCAN", "TROUT", "TUNA", "TURKEY", "TURTLE", "VIPER", "VOUL", "VULTURE", "WALLABY", "WALRUS", "WARTHOG", "WASP", "WEASEL", "WHALE", "WHIPPET", "WILDEBEEST", "WOLF", "WOLVERINE", "WOMBAT", "WOODLOUSE", "WOODPECKER", "WOODRAT", "WORM", "ZEBRA"],
				Countries: ["AFGHANISTAN", "ALBANIA", "ALGERIA", "AMERICA", "ANDORRA", "ANGOLA", "ANGUILLA", "ANTIGUA AND BARBUDA", "ARGENTINA", "ARMENIA", "ARUBA", "AUSTRALIA", "AUSTRIA", "AZERBAIJAN", "BAHAMAS", "BAHRAIN", "BANGLADESH", "BARBADOS", "BELARUS", "BELGIUM", "BELIZE", "BENIN", "BERLIN", "BERMUDA", "BHUTAN", "BOLIVIA", "BOSNIA", "BOTSWANA", "BRAZIL", "BRUNEI", "BULGARIA", "BURKINA FASO", "BURMA", "BURUNDI", "CAMBODIA", "CAMEROON", "CANADA", "CAPE VERDE", "CAYMAN ISLANDS", "CHAD", "CHILE", "CHINA", "COLOMBIA", "COMOROS", "CONGO", "COSTA RICA", "CROATIA", "CUBA", "CYPRUS", "CZECH REPUBLIC", "DENMARK", "DJIBOUTI", "DOMINICA", "DOMINICAN REPUBLIC", "ECUADOR", "EGYPT", "EL SALVADOR", "ERITREA", "ESTONIA", "ETHIOPIA", "FIJI", "FINLAND", "FRANCE", "GABON", "GAMBIA", "GEORGIA", "GERMANY", "GHANA", "GIBRALTAR", "GREECE", "GREENLAND", "GRENADA", "GUATEMALA", "GUERNSEY", "GUINEA", "GUYANA", "HAITI", "HONDURAS", "HONG KONG", "HUNGARY", "ICELAND", "INDIA", "INDONESIA", "IRAN", "IRAQ", "IRELAND", "ISRAEL", "ITALY", "IVORY COAST", "JAMAICA", "JAPAN", "JERSEY", "JORDAN", "KAZAKHSTAN", "KENYA", "KIRIBATI", "KOREA", "KUWAIT", "LAOS", "LATVIA", "LEBANON", "LIBERIA", "LIBYA", "LITHUANIA", "LUXEMBOURG", "MACEDONIA", "MADAGASCAR", "MALAWI", "MALAYSIA", "MALDIVES", "MALI", "MALTA", "MAURITANIA", "MAURITIUS", "MEXICO", "MOLDOVA", "MONACO", "MONGOLIA", "MONTENEGRO", "MONTSERRAT", "MOROCCO", "MOZAMBIQUE", "NAMIBIA", "NAURU", "NEPAL", "NETHERLANDS", "NEW ZEALAND", "NICARAGUA", "NIGER", "NIGERIA", "NIUE", "NORFOLK ISLAND", "NORWAY", "OMAN", "PAKISTAN", "PALAU", "PANAMA", "PAPUA NEW GUINEA", "PARAGUAY", "PERU", "PHILIPPINES", "POLAND", "PORTUGAL", "PUERTO RICO", "QATAR", "ROMANIA", "RUSSIA", "RWANDA", "SAINT LUCIA", "SAINT VINCENT", "SAMOA", "SAUDI ARABIA", "SENEGAL", "SERBIA", "SIERRA LEONE", "SINGAPORE", "SLOVAKIA", "SLOVENIA", "SOMALIA", "SOUTH AFRICA", "SOUTH KOREA", "SPAIN", "SRI LANKA", "SUDAN", "SWEDEN", "SWITZERLAND", "SYRIA", "TAIWAN", "TANZANIA", "THAILAND", "TONGA", "TUNISIA", "TURKEY", "TUVALU", "UGANDA", "UKRAINE", "UNITED ARAB EMIRATES", "UNITED KINGDOM", "UNITED STATES", "URUGUAY", "USA", "VENEZUELA", "VIETNAM", "YEMEN", "ZAMBIA", "ZIMBABWE"],
				ComboMix: ["ANT", "APHID", "APPLE", "APRICOT", "APRIL", "AQUARIUS", "ARIES", "AUGUST", "AUNT", "AUNTIE", "AVOCADO", "BANANA", "BEE", "BEETLE", "BLACK", "BLOSSOM", "BLUE", "BLUEBELL", "BLUEBERRY", "BROWN", "BUMBLEBEE", "BUTTERCUP", "BUTTERFLY", "CANCER", "CAPRICORN", "CATERPILLAR", "CENTIPEDE", "CHERRY", "CIRCLE", "CLEMENTINE", "CLOVER", "COCKROACH", "COCONUT", "CROSS", "CUBE", "CYLINDER", "DAFFODIL", "DAISY", "DECEMBER", "DODECAHEDRON", "DRAGONFLY", "EARTH", "FEBRUARY", "FLOWER", "FLY", "FLYTRAP", "FRUITFLY", "GDAŃSK", "GEMINI", "GERANIUM", "GOLD", "GRAPE", "GRAPEFRUIT", "GRASS", "GREEN", "GREY", "HEXAGON", "HORNET", "INDIGO", "JANUARY", "JULY", "JUNE", "JUNIPER", "JUPITER", "KIWI", "LADYBIRD", "LADYBUG", "LEMON", "LEO", "LIBRA", "LILLY", "LILY", "LIME", "LIZARD", "MAGENTA", "MAGGOT", "MARCH", "MARS", "MAY", "MAYFLY", "MERCURY", "MOON", "MOSQUITO", "MOTH", "NEPTUNE", "NOVEMBER", "OBLONG", "OCTAGON", "OCTOBER", "ORANGE", "ORCHID", "PANSY", "PEAR", "PENTAGON", "PINEAPPLE", "PINK", "PISCES", "PLUTO", "PLUTO", "PURPLE", "RED", "ROSE", "SAGITTARIUS", "SATURN", "SCORPIO", "SEPTEMBER", "SILVER", "SPIDER", "SQUARE", "STAR", "STRAWBERRY", "SUN", "SUNFLOWER", "TAURUS", "ΤΟΜΑΤΟ", "TRIANGLE", "TULIP", "URANUS", "VENUS", "VIOLET", "VIRGO", "WASP", "WHITE", "WORM", "YELLOW"]
			},
			straightLetters: ["A", "E", "F", "H", "I", "K", "L", "M", "N", "T", "V", "W", "X", "Y", "Z", "É", "À", "Â", "Ã", "Á", "Ä", "Å", "Ă", "Î", "Ț", "Ê", "Ŵ", "Ŷ", "Ï", "Í", "È", "Æ", "Ë", "Ÿ", "Ẽ", "Ĩ", "Ỹ", "Ñ"],
			curvedLetters: ["C", "O", "S", "G", "O", "Q", "S", "U", "Ç", "Ö", "Õ", "Ș", "Ô", "Ó", "Ò", "Ş"],
			bothLetters: ["B", "D", "G", "J", "P", "Q", "R", "U", "Ú", "Ü", "ß", "Û", "Œ", "Ù", "Ũ", "G̃"],
			vowels: ["A", "I", "U", "E", "O", "À", "Â", "Æ", "É", "È", "Ê", "Ë", "Î", "Ï", "Í", "Ô", "Œ", "Ù", "Û", "Ü", "Ö", "Ä", "Ó", "Ú", "Ã", "Õ", "Á", "Å", "Ă", "Ò", "Ẽ", "Ĩ", "Ũ"],
			selectedCategories: null,
			selectedWord: "",
			selectedCategory: '',
			wordLength: 0,
			vowelPositions: [null, null],
			letterShape: "",
			reveal: false,
			revealedLetterShape: false,
			revealedCategory: false,
			considerYAsVowel: false,
			generatedWordFromLetter: '',
			lightPositions: [
				{ x: '15.5%', y: '16%' },
				{ x: '21.3%', y: '7%' },
				{ x: '29.6%', y: '4%' },
				{ x: '34.3%', y: '11%' },
				{ x: '45%', y: '45%' },
				{ x: '50%', y: '50%' },
				{ x: '61.5%', y: '7%' },
				{ x: '69%', y: '2%' },
				{ x: '75.3%', y: '4%' },
				{ x: '80.5%', y: '12%' },
			],
			activeLight: 0,
			gameStarted: false,
			showSettings: false,
		};
	},
	created() {
		document.title = "Enigma Training Tool";

		const savedSetting = localStorage.getItem('considerYAsVowel');
		if (savedSetting !== null) {
			this.considerYAsVowel = JSON.parse(savedSetting);
		}

		const savedSelectedCategories = localStorage.getItem('selectedCategories');
		if (savedSelectedCategories !== null) {
			this.selectedCategories = JSON.parse(savedSelectedCategories);
		} else {
			// If there's no saved selection, default to all categories
			this.selectedCategories = Object.keys(this.categories);
		}

		const isLoggedIn = localStorage.getItem('isLoggedIn');
		this.loggedIn = isLoggedIn === 'true';
	},
	watch: {
		considerYAsVowel(newVal) {
			localStorage.setItem('considerYAsVowel', newVal);
		},
		selectedCategories: {
			handler(newVal) {
				localStorage.setItem('selectedCategories', JSON.stringify(newVal));
			},
			deep: true
		}
	},
	methods: {
		checkPassword() {
			if (this.password === this.correctPassword) {
				this.loggedIn = true;
				this.loginFailed = false;
				localStorage.setItem('isLoggedIn', 'true');
			} else {
				this.password = '';
				this.loginFailed = true;
			}
		},
		startGame() {
			this.gameStarted = true;
			this.showSettings = false;
			this.generateWord();
		},
		resetWord() {
			this.reveal = false;  // Hide the revealed word
			this.gameStarted = false;
			this.selectedCategory = '';
			this.selectedWord = '';
			this.wordLength = 0;
			this.vowelPositions = [null, null]
			this.letterShape = '';
			this.generatedWordFromLetter = '';
			this.revealedCategory = false;
			this.revealedLetterShape = false;
		},
		generateWord() {
			const availableCategories = this.selectedCategories.length ? this.selectedCategories : Object.keys(this.categories);
			this.selectedCategory = availableCategories[Math.floor(Math.random() * availableCategories.length)];

			// Pick a random word from the selected category
			const words = this.categories[this.selectedCategory];
			this.selectedWord = words[Math.floor(Math.random() * words.length)];
			var selectedWordWithoutSpaces = this.selectedWord.replace(/\s+/g, '')

			this.wordLength = selectedWordWithoutSpaces.length;

			this.vowelPositions = this.getVowelPositions(selectedWordWithoutSpaces, true); // Assuming Y is considered as a vowel by default
			this.letterShape = this.getLetterShape(this.selectedWord[0]);
		},
		getVowelPositions(word) {
			const vowels = this.considerYAsVowel ? "AEIOUY" : "AEIOU";
			const positions = [];

			for (let i = 0; i < word.length; i++) {
				if (vowels.includes(word[i].toUpperCase())) {
					positions.push(i + 1);
				}
			}

			return [positions[0] || null, positions[1] || null];
		},
		getLetterShape(letter) {
			if (this.straightLetters.includes(letter.toUpperCase())) {
				return "Straight Lines";
			} else if (this.curvedLetters.includes(letter.toUpperCase())) {
				return "Curved Lines";
			} else if (this.bothLetters.includes(letter.toUpperCase())) {
				return "Both Curved and Straight Lines";
			}
			return "Unknown";
		},
		revealWord() {
			this.reveal = true;
		},
		async showWordLength() {
			for (let i = 0; i < this.wordLength; i++) {
				this.activeLight = 10 - (i % 10);
				await this.wait(500); // Wait for 0.5 seconds
				this.activeLight = 0;
				await this.wait(500); // Wait for 0.5 seconds before moving to the next light
			}
		},
		async showFirstVowel() {
			this.activeLight = 10 - this.vowelPositions[0] + 1;
			await this.wait(1000);
			this.activeLight = 0;
		},
		async showSecondVowel() {
			this.activeLight = 10 - this.vowelPositions[1] + 1;
			await this.wait(1000);
			this.activeLight = 0;
		},
		revealLetterShape() {
			this.revealedLetterShape = true;
		},
		wait(ms) {
			return new Promise(resolve => setTimeout(resolve, ms));
		},
		revealCategory() {
			this.revealedCategory = true;
		},
		updateYAsVowelSetting(newVal) {
			localStorage.setItem('considerYAsVowel', newVal);
		},
		getWordFromLetterIndex(index) {
			let selectedLetter;

			selectedLetter = this.selectedWord[index - 1]

			if (!selectedLetter) {
				this.generatedWordFromLetter = "Word is too short!";
				return;
			}

			let possibleWords = [];
			for (const cat in this.categories) {
				possibleWords = possibleWords.concat(this.categories[cat].filter(word => word[0].toUpperCase() === selectedLetter.toUpperCase()));
			}

			if (possibleWords.length === 0) {
				this.generatedWordFromLetter = `No words found starting with ${selectedLetter}`;
				return;
			}

			this.generatedWordFromLetter = possibleWords[Math.floor(Math.random() * possibleWords.length)];
		},
		getOrdinalNumber(n) {
			const s = ["th", "st", "nd", "rd"];
			const v = n % 100;
			return n + (s[(v - 20) % 10] || s[v] || s[0]);
		}
	}
};
</script>

<style scoped>
.login-form {
	position: absolute;
	top: 0;
	left: 50%;
	transform: translateX(-50%);
	background-color: #fff;
	border-radius: 10px;
	padding: 20px;
	width: 500px;
	max-width: 100%;
	color: #000;
	text-align: left;
}

.login-form input {
	width: 100%;
	border: 1px solid grey;
	padding: 15px 10px;
	border-radius: 10px;
	margin-bottom: 20px;
}

.login-form button {
	display: block;
	margin: 0 auto;
	background-color: #d6b30b;
	color: #fff;
	padding: 20px;
	border-radius: 5px;
}

.hand-container {
	position: relative;
	width: 1920px;
	max-width: 100%;
	margin: 0 auto;
}

.hand-container .bg-gradient {
	position: absolute;
	bottom: 0;
	left: 0;
	width: 100%;
	height: 50%;
	background: linear-gradient(0deg, #000 11%, transparent);
}

.hand-container img {
	object-fit: cover;
	max-width: 100%;
	height: auto;
}

.hand-container .reveal {
	position: absolute;
	top: 0;
	left: 50%;
	transform: translateX(-50%);
}

.light-effect {
	position: absolute;
	width: 2vw;
	height: 2vw;
	background:
		radial-gradient(circle, rgba(214, 179, 11, 0.2), transparent 40%),
		radial-gradient(circle, rgba(214, 179, 11, 0.4), transparent 30%),
		radial-gradient(circle, rgba(214, 179, 11, 0.6), transparent 20%),
		radial-gradient(circle, #D6B30B, #D6B30B 50%, transparent 70%);
	border-radius: 50%;
	filter: drop-shadow(0 0 15px #D6B30B) drop-shadow(0 0 25px #D6B30B) drop-shadow(0 0 35px #D6B30B);
	z-index: 9999;
	opacity: 0;
	/* Default state is hidden */
	transition: opacity 0.5s;
	/* Half-second fade in/out */
}

.light-effect.active-light {
	opacity: 1;
}

.controls {
	position: fixed;
	bottom: 5%;
	left: 50%;
	transform: translateX(-50%);
	z-index: 1000;
}

.controls h2 {
	color: #000;
	margin: 20px 0 10px 0;
}

.controls .game-controls {
	background-color: #fff;
	border-radius: 10px;
	width: 800px;
	max-width: 100%;
	padding: 20px;
}

button {
	font-family: sans-serif;
	font-size: 16px;
	font-weight: 600;
	border-radius: 4px;
	color: #fff;
	margin: 5px;
	cursor: pointer;
	background-color: transparent;
	color: #D6B30B;
	text-decoration: underline;
}

button.btn {
	font-size: 20px;
	padding: 10px 20px;
	border-radius: 5px;
	background-color: #D6B30B;
	color: #000;
	text-decoration: none;
}

button.btn.light {
	background-color: lightgrey;
	color: #000;
	text-decoration: none;
}

.settings-popup {
	position: fixed;
	top: 50%;
	left: 50%;
	transform: translate(-50%, -50%);
	width: 400px;
	max-width: 100%;
	padding: 20px;
	background-color: #ffffff;
	border: 1px solid #cccccc;
	border-radius: 5px;
	box-shadow: 0 0 10px rgba(0, 0, 0, 0.1);
	z-index: 1000;
	color: black;
	text-align: left;
}

.settings-popup .close {
	position: absolute;
	top: 10px;
	right: 10px;
	cursor: pointer;
}

.settings-popup .section {
	margin: 20px 0;
}

.settings-popup .section input,
.settings-popup .section label {
	cursor: pointer;
}

.reveal {
	font-size: 30px;
}

.message {
	font-weight: 700;
	font-size: 25px;
	margin: 10px 0;
}

@media (max-width: 767px) {
	.hand-container {
		margin-top: 50px;
	}

	.reveal {
		top: -50px !important;
		font-size: 20px;
		width: 100%;
	}

	.message {
		font-size: 20px;
	}

	.controls {
		width: 100%;
	}

	.controls h2 {
		font-size: 18px;
	}

	.controls .game-controls {
		width: 100%;
	}

	.controls br {
		display: none;
	}
}

@media (max-height: 768px) {
	.hand-container {
		width: 700px;
	}
}
</style>